module.exports = __webpack_public_path__ + "media/images/icons/close-a21185aeda426416972d4d78f906e4db.svg";